import React, { useState } from "react";
import logo from "../../images/whiteLogo.png";
import { Link, useHistory } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { useSelector, useDispatch } from "react-redux";
import { useToasts } from "react-toast-notifications";
import config from "../../config/config";
import { logoutAction } from "../../redux/actions/logoutAction";
var Constants = require("../constants.json");

const Nav = (props) => {
  let history = useHistory();
  const genusList = useSelector((state) => state.genusReducer);
  const genusSelected = localStorage.getItem("genus")
    ? localStorage.getItem("genus")
    : Constants["defaultGenus"];
  const [searchkey, setSearchkey] = useState(props.searchkey);
  const [genus, setGenus] = useState(genusSelected);
  const optionList = props.optionList;
  const { addToast } = useToasts();
  const dispatch = useDispatch();
  let focusOutTimer;

  const logoutClicked = (e) => {
    e.preventDefault();
    dispatch(logoutAction());
    history.push("/");
    addToast("You are logged out successfully!", {
      appearance: "success",
      autoDismiss: true,
    });
  };

  const openLoginModal = (e) => {
    e.preventDefault();
    dispatch({ type: "LOGIN_MODAL_OPEN" });
  };

  const logInResponse = useSelector((state) => state.loginReducer);

  React.useEffect(() => {
    return () => {
      clearTimeout(focusOutTimer);
    };
  });

  function changeSearchkey(e) {
    if (e.target.value === "" || e.key === "Enter" || e.keyCode === 13) {
      document.querySelector(".autosuggest").style.display = "none";
      document.querySelector(".search-input").classList.remove("selected");
      document.querySelector(".blue-vert-line").classList.remove("selected");
      document.querySelector(".srch-filter").classList.remove("selected");
    } else {
      document.querySelector(".autosuggest").style.display = "block";
      document.querySelector(".search-input").classList.add("selected");
      document.querySelector(".blue-vert-line").classList.remove("selected");
      document.querySelector(".srch-filter").classList.add("selected");
    }
    let srchkey = e.target.value;
    setSearchkey(srchkey);
    props.changeSearchkey(srchkey);
  }
  function handleGenusChange(ge) {
    localStorage.setItem("genus", ge);
    setGenus(ge);
    if (searchkey !== "") {
      props.onFormSubmit({ searchkey: searchkey, searchgenus: ge });
      document.querySelector(".mobile-search-view").style.display = "none";
    }
  }

  function handleSearchTopicSubmit(e) {
    e.preventDefault();
    if (
      document.querySelector(
        ".autosuggest .autosuggest-container ul li.selected"
      ) === null
    ) {
      if (searchkey !== "") {
        props.onFormSubmit({ searchkey: searchkey, searchgenus: genus });
        document.querySelector(".mobile-search-view").style.display = "none";
      }
    } else {
      document
        .querySelector(".autosuggest .autosuggest-container ul li.selected a")
        .click();
    }
  }
  function selectGenus(e) {
    setGenus(e.target.value);
    localStorage.setItem("genus", e.target.value);
    if (searchkey !== "") {
      props.onFormSubmit({ searchkey: searchkey, searchgenus: e.target.value });
    }
  }

  const inputKeyPress = (event) => {
    changeSearchkey(event);
    let srchOptions = document.querySelectorAll(
      ".autosuggest .autosuggest-container ul li"
    );
    // console.log("key down");
    if (document.querySelector(".autosuggest .autosuggest-container") != null) {
      if (event.keyCode === 38) {
        // console.log("up arrow");
        event.preventDefault();
        if (
          document.querySelector(
            ".autosuggest .autosuggest-container ul li.selected"
          ) === null
        ) {
          document
            .querySelector(
              `.autosuggest .autosuggest-container ul li#\\3${
                srchOptions.length - 1
              }`
            )
            .classList.add("selected");
        } else if (
          document.querySelector(
            ".autosuggest .autosuggest-container ul li.selected"
          ).id === "0"
        ) {
          document
            .querySelector(".autosuggest .autosuggest-container ul li.selected")
            .classList.remove("selected");
        } else {
          let currentSelectedId = Number(
            document.querySelector(
              ".autosuggest .autosuggest-container ul li.selected"
            ).id
          );
          document
            .querySelector(".autosuggest .autosuggest-container ul li.selected")
            .classList.remove("selected");
          document
            .querySelector(
              `.autosuggest .autosuggest-container ul li#\\3${
                (currentSelectedId - 1) % srchOptions.length
              }`
            )
            .classList.add("selected");
        }
      } else if (event.keyCode === 40) {
        event.preventDefault();
        // console.log("down arrow");
        if (
          document.querySelector(
            ".autosuggest .autosuggest-container ul li.selected"
          ) === null
        ) {
          document
            .querySelector(`.autosuggest .autosuggest-container ul li#\\30`)
            .classList.add("selected");
        } else if (
          document.querySelector(
            ".autosuggest .autosuggest-container ul li.selected"
          ).id === (srchOptions.length - 1).toString()
        ) {
          document
            .querySelector(".autosuggest .autosuggest-container ul li.selected")
            .classList.remove("selected");
        } else {
          let currentSelectedId = Number(
            document.querySelector(
              ".autosuggest .autosuggest-container ul li.selected"
            ).id
          );
          document
            .querySelector(".autosuggest .autosuggest-container ul li.selected")
            .classList.remove("selected");
          document
            .querySelector(
              `.autosuggest .autosuggest-container ul li#\\3${
                (currentSelectedId + 1) % srchOptions.length
              }`
            )
            .classList.add("selected");
        }
      }
    }
  };

  const inputFocusOut = () => {
    focusOutTimer = setTimeout(() => {
      document.querySelector(".autosuggest").style.display = "none";
      document.querySelector(".search-input").classList.remove("selected");
      document.querySelector(".blue-vert-line").classList.remove("selected");
      document.querySelector(".srch-filter").classList.remove("selected");
    }, 200);
  };

  const documentScrollingCheck = () => {
    if (document.querySelector(".header") !== null) {
      if (
        document.documentElement.scrollTop >
        document.querySelector(".header").scrollHeight - 50
      ) {
        document.querySelector(".nav").style.position = "fixed";
      } else {
        document.querySelector(".nav").style.position = "unset";
      }
    } else if (document.querySelector(".search-result") !== null) {
      if (document.documentElement.scrollTop > 20) {
        document.querySelector(".autosuggest").style.display = "none";
        document.querySelector(".search-input").classList.remove("selected");
        document.querySelector(".blue-vert-line").classList.remove("selected");
        document.querySelector(".srch-filter").classList.remove("selected");
        document.querySelector(".nav").style.position = "fixed";
      } else {
        document.querySelector(".nav").style.position = "unset";
      }
    }
  };

  const openCloseProfile = () => {
    if (
      document
        .querySelector(".user-arrow")
        .classList.contains("user-arrow-rotate")
    ) {
      document
        .querySelector(".user-arrow")
        .classList.remove("user-arrow-rotate");
      document.querySelector(".profile-dropdown-box").style.display = "none";
    } else {
      document.querySelector(".user-arrow").classList.add("user-arrow-rotate");
      document.querySelector(".profile-dropdown-box").style.display = "block";
    }
  };

  document.addEventListener("scroll", function () {
    documentScrollingCheck();
  });

  return (
    <div>
      <div className="mobile-search-view" style={{ display: "none" }}>
        <div className="mobile-search-row">
          <div className="mobile-search-input">
            <FontAwesomeIcon icon={faSearch} className="icon" />
            <form
              onSubmit={(e) => handleSearchTopicSubmit(e)}
              className="form-inline"
            >
              <input
                type="text"
                placeholder="Search"
                id="srchNewInput"
                value={props.searchkey}
                onChange={changeSearchkey}
                onKeyDown={changeSearchkey}
                autoComplete="off"
              />
            </form>
          </div>
          <p
            className="cancel-search-text"
            onClick={() =>
              (document.querySelector(".mobile-search-view").style.display =
                "none")
            }
          >
            Cancel
          </p>
        </div>
        <div className="search-filter-row">
          <p>On This Page</p>
          <p>The Full Site</p>
        </div>
        {genusList && genusList.response && (
          <div className="search-cat-row">
            <label htmlFor="filter">FILTER BY</label>
            <select
              name="genus-list"
              id="genus-list"
              value={genus}
              onChange={(e) => handleGenusChange(e.currentTarget.value)}
            >
              {genusList.response.map((genus) => (
                <option key={genus.id} value={genus.genus}>
                  {genus.genus}
                </option>
              ))}
            </select>
          </div>
        )}
        <div className="recent-search">{optionList}</div>
      </div>
      <div className="nav">
        <div className="mobile-search">
          <FontAwesomeIcon
            icon={faSearch}
            className="icon"
            onClick={() =>
              (document.querySelector(".mobile-search-view").style.display =
                "block")
            }
          />
        </div>
        <div className="tablet-back">
          <i className="fa fa-angle-left" aria-hidden="true"></i>
        </div>
        <div className="logo">
          <Link to="/">
            <img src={logo} alt="" />
          </Link>
        </div>
        <div className="search-input">
          {genusList && genusList.response && (
            <div className="search-input-child">
              <FontAwesomeIcon icon={faSearch} className="icon" />
              <form
                onSubmit={(e) => handleSearchTopicSubmit(e)}
                className="form-inline"
              >
                <input
                  type="text"
                  id="srchInput"
                  placeholder="What condition do you want to learn about?"
                  value={props.searchkey}
                  onChange={(e) => changeSearchkey(e)}
                  onKeyDown={inputKeyPress}
                  onBlur={inputFocusOut}
                  autoComplete="off"
                />
                <span className="blue-vert-line"></span>
                <div className="srch-filter">
                  <select
                    className="srch-dropdown"
                    value={genus}
                    onChange={selectGenus}
                  >
                    {genusList.response.map((genus) => (
                      <option key={genus.id} value={genus.genus}>
                        {genus.genus}
                      </option>
                    ))}
                  </select>
                </div>
              </form>
            </div>
          )}
          <div className="autosuggest">{optionList}</div>
        </div>
        <div>
          <div className="user">
            {logInResponse.isLoggedIn ? (
              <>
                <p>{logInResponse.firstName + " " + logInResponse.lastName}</p>
                <span className="user-arrow" onClick={openCloseProfile}>
                  <i className="fa fa-caret-down" aria-hidden="true"></i>
                </span>
                <div className="profile-dropdown-box">
                  <a href={`/${config.LOCALE}/checkout/subscription-details`}>
                    <p>View Account</p>
                  </a>
                  <p onClick={logoutClicked}>Log Out</p>
                </div>
              </>
            ) : (
              <p onClick={openLoginModal} className="cpointer">
                Login
              </p>
            )}
          </div>
          <div className="mobile-profile">
            <span>
              {logInResponse.isLoggedIn ? (
                logInResponse.firstName[0].toUpperCase()
              ) : (
                <i onClick={openLoginModal} className="fa fa-user"></i>
              )}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Nav;
